export enum ListSortBy {
    CREATED = 'created',
    DURATION = 'duration',
    TIME = 'time',
    TIME_NAME = 'time:name',
    TYPE = 'type',
    TYPE_TIME = 'type:time',
    NAME = 'name',
    NAME_TIME = 'name:time',
    LOCALITY = 'locality',
    LOCALITY_TIME = 'locality:time',
    EXPIRE_AT = 'expire_at',
    STATUS = 'status',
    WORKER = 'worker',
    USER = 'user',
    COMPANY = 'company',
    REQUESTED_AT = 'requested_at',
    ROLE = 'role',
    START = 'start',
    START_AT = 'start_at',
    END = 'end',
    STATUS_TIME_TYPE = 'status:time:type'
};
